import { useCallback } from 'react'
import { store, Content } from 'bxl-legocore'

export default function usePageConfig() {
  const handle = useCallback(
    (state: Content) => state.root?.config,
    []
  );
  return store(handle);
}